import instance from "../config/axios";
import { base_apis } from "../config/url";

export const rewardCategoryList = (data) => {
    return instance.post(`${base_apis.rewardCategory}/category-list`, data)
        .then((res) => {
            return res;
        });
};